import { Component, EventEmitter, Input, OnDestroy, OnInit, Output } from '@angular/core';
import { AbstractControl, UntypedFormControl, UntypedFormGroup, Validators } from '@angular/forms';
import { DetailsSectionEnum } from '@app/core/enums';
import { ClaimNotificationInterface, RelationInterface, SaveClaimNotificationPayloadInterface } from 'outshared-lib';
import { Subscription } from 'rxjs';
import { ClaimNotificationIndicationEnum } from './claim-notification-indication.enum';

@Component({
    selector: 'ins-claim-notification',
    templateUrl: './claim-notification.component.html',
    styleUrls: ['./claim-notification.component.scss'],
})
export class ClaimNotificationComponent implements OnInit, OnDestroy {
    @Input() relation: RelationInterface;
    @Input('claimNotification') set setClaimNotification(claimNotification: ClaimNotificationInterface) {
        if (claimNotification && this.form) {
            const emailNotificationIndication = this.mapBooleanToIndication(
                claimNotification.emailNotificationIndication,
            );
            const smsNotificationIndication = this.mapBooleanToIndication(claimNotification.smsNotificationIndication);

            this.caseSequenceNumber.patchValue(claimNotification.caseSequenceNumber, { emitEvent: false });
            this.emailNotificationIndication.patchValue(emailNotificationIndication, { emitEvent: false });
            this.smsNotificationIndication.patchValue(smsNotificationIndication, { emitEvent: false });
        }
    }

    @Output() readonly submitted = new EventEmitter<SaveClaimNotificationPayloadInterface>();

    public form: UntypedFormGroup;
    public detailsSectionEnum: typeof DetailsSectionEnum;
    public claimNotificationIndicationEnum: typeof ClaimNotificationIndicationEnum;

    private subscription: Subscription;

    ngOnInit(): void {
        let valueChanges: Subscription;

        this.subscription = new Subscription();
        this.detailsSectionEnum = DetailsSectionEnum;
        this.claimNotificationIndicationEnum = ClaimNotificationIndicationEnum;
        this.form = this.createForm();

        valueChanges = this.form.valueChanges.subscribe((values) => this.onValueChanges(values));

        this.subscription.add(valueChanges);
    }

    ngOnDestroy(): void {
        this.subscription.unsubscribe();
    }

    get caseSequenceNumber(): AbstractControl {
        return this.form.get('caseSequenceNumber');
    }

    get emailNotificationIndication(): AbstractControl {
        return this.form.get('emailNotificationIndication');
    }

    get smsNotificationIndication(): AbstractControl {
        return this.form.get('smsNotificationIndication');
    }

    public onValueChanges(values): void {
        const emailNotificationIndication = this.mapIndicationToBoolean(values.emailNotificationIndication);
        const smsNotificationIndication = this.mapIndicationToBoolean(values.smsNotificationIndication);
        const caseSequenceNumber: number = values.caseSequenceNumber;

        this.submitted.emit({ caseSequenceNumber, emailNotificationIndication, smsNotificationIndication });
    }

    private createForm(): UntypedFormGroup {
        return new UntypedFormGroup({
            caseSequenceNumber: new UntypedFormControl(),
            emailNotificationIndication: new UntypedFormControl(null, [Validators.required]),
            smsNotificationIndication: new UntypedFormControl(null, [Validators.required]),
        });
    }

    // cyno-radio only accepts string or numbers; 'yes' => true.
    private mapIndicationToBoolean(indication: ClaimNotificationIndicationEnum): boolean {
        return Boolean(indication === ClaimNotificationIndicationEnum.Yes);
    }

    // cyno-radio only accepts string or numbers; true => 'yes'.
    private mapBooleanToIndication(boolean: boolean): ClaimNotificationIndicationEnum {
        return boolean ? ClaimNotificationIndicationEnum.Yes : ClaimNotificationIndicationEnum.No;
    }
}
